import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";

export default function OAuthCallbackComplete() {
    const location = useLocation();
    const navigate = useNavigate();
    const hasRun = useRef(false);

    useEffect(() => {
        if (hasRun.current) return;
        hasRun.current = true;

        console.log('OAuthComplete');

        const params = new URLSearchParams(location.search);
        if (params.get("status") === "success") {
            alert("Success: MHIDs refreshed");
            navigate("/");
        } else if (params.get("status") === "error") {
            alert("Refresh from GIS unsuccessful");
            navigate("/");
        }
    }, [location, navigate]);

    return <div>Completing authentication...</div>;
}